import { styled } from '../jss-style';
import editableAreaStyle from './editable-area';

const useEditableAreaStyle = styled(editableAreaStyle, 'editableArea');
export { editableAreaStyle, useEditableAreaStyle };
export default useEditableAreaStyle;
